import { Location } from '@lib.core/entities/location/location';
import {
  AspectIndustry,
  AspectOccupation,
  AspectProduct
} from '@lib.core/entities/indicator/indicator';

export class AspectContext {
  location?: Location;
  industry?: AspectIndustry;
  occupation?: AspectOccupation;
  product?: AspectProduct;

  constructor(
    location?: Location,
    industry?: AspectIndustry,
    occupation?: AspectOccupation,
    product?: AspectProduct,
  ) {
    this.location = location;
    this.industry = industry;
    this.occupation = occupation;
    this.product = product;
  }
}
